import { h } from 'preact';
import './CartSummary.scss';
import CurrencyFormat from './ui/CurrencyFormat';
import PropTypes from 'prop-types';
import store from '../store';

function CartSummary(props) {
  const shopper = props.shopper || {};
  const shopperCart = shopper.cart || { items: [] };
  const cartItems = shopperCart.items;

  if (cartItems.length === 0) {
    return null;
  }

  const totalQty = cartItems.reduce((total, item) => total + item.qty, 0);
  const totalAmount = cartItems.reduce((total, item) => total + (item.qty * (item.price ? item.price.amount : 0)), 0) / 100;

  // Assume all items in cart are the same currency (no multi-currency support)
  const currency = cartItems.length > 0 ? cartItems[0].price.currency : 'USD';

  return (
    <div className="_ic _ic__cartSummary" onClick={handleCartClick}>
      <div className="_ic__cartSummary-icon"><img src={getCartIcon()} width="24" height="24" alt="Cart" /></div>
      <div className="_ic__cartSummary-amount"><span><CurrencyFormat amount={totalAmount} currency={currency} /></span></div>
      <div className="_ic__cartSummary-items"><span>{totalQty} items</span></div>
    </div>
  );
}

CartSummary.propTypes = {
  shopper: PropTypes.object.required,
};

function getCartIcon() {
  return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAECSURBVEhL3ZQ9agJRFEZHi0hIYaG1QgpXoGsQtLBwK+7B4BqEpBBXYBmIta2tVZJKW/GnMHq+wcBDfeOdMAPGA4dhPu6d+35ggrth7/imIGncASssYiqM0B32Fz/QSwMvNcVxil6yOEMVapiVPC5QfS0FUXRQhTouKy+onnH4dgVdsC56h88KrlDGNf5gVYGFV9SKeuFbNANUrZ5maqgmneujAg+q08q1g5KCOExQQyx2MRYFnOOlj7lq5UPMYSz6qA+8Y0ZBkjzhBrdYUZA0D7jE0+OwaKaNljs49XZo4vfRqH+Ste6ML/zd9qcCD9a6M1IfoO2qWU11BR6sdf+WIDgAsSyOLDuabGwAAAAASUVORK5CYII=';
}

function handleCartClick() {
  window.IncludeCart.api.cartToggle();
}

export default store.connect(CartSummary, {
  shopper: 'shopper',
});
